(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const $get = id => document.getElementById(id);

        const newTable = $get("mainTable");

        const tJsonW = $get("JSONRoadType") as HTMLTextAreaElement; 
        let roadTypes = JSON.parse(tJsonW.value);

        const tJsonTitle = $get("JSONTitle") as HTMLTextAreaElement;
        const titleData = JSON.parse(tJsonTitle.value);

        const tJson = $get("JSONData") as HTMLTextAreaElement;
        const compactionData = tJson.value;
        
        const allData = JSON.parse(compactionData);

        const container = $get("mainTable");

        let innerHTML = `
            <div class="row">
                <div class="form-group col-lg-7 mt-2 mb-1">
                    <label for="materialTypeDropdown">Type of material</label>
                    <div>
                        <span id="materialTypeDropdown"> </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-lg-7 mt-2">
                    <label for="">Road type:</label><br />

                        `;

        roadTypes.forEach((x) => {
            innerHTML += `<input style="margin-left: 7px" type="checkbox" name="ww" value="${x}" />&nbsp;<b>${x}</b><br /> `
        }
        );

        innerHTML += `
                    
               </div>
            </div>
            <div class="row mt-1">
                <div class="form-group col-lg-7 mt-1">
                    <button id="btnShowRequirements"
                                name="command"
                                value="search"
                                type="submit"
                                class="ml-1 mt-2 btn btn-primary">
                            Show requirements
                    </button>
                </div>
           </div>

            <div id="tblRequirements" class="mt-3"></div>
        `

        container.innerHTML = innerHTML;

        const materialTypeSelect = document.createElement("select");
        materialTypeSelect.id = "materialTypeSelect";
        materialTypeSelect.className += "ml-1 form-control form-select";
        materialTypeSelect.style.fontWeight = "bold";
        $get("materialTypeDropdown").appendChild(materialTypeSelect);

        const option = document.createElement("option");
        option.value = "1";
        option.text = "Hot lay flexible materials";
        materialTypeSelect.appendChild(option);


        const btnShowRequirementsClick = function (event) {

            const dataRow = allData[0];

            const lValues: string[] = [];

            $("input:checkbox[name=ww]:checked").each(function () {
                lValues.push(String($(this).val()));
            });

            const invalidSelection = lValues.length === 0;

            if (!invalidSelection) {

                let section1DataRowCount = 0;

                lValues.forEach((x) => {
                    if (dataRow.HRA.find(i => i.key === x).value.length > section1DataRowCount) {
                        section1DataRowCount = dataRow.HRA.find(i => i.key === x).value.length
                    }
                });

                let section2DataRowCount = 0;

                lValues.forEach((x) => {
                    if (dataRow.SMA.find(i => i.key === x).value.length > section2DataRowCount) {
                        section2DataRowCount = dataRow.SMA.find(i => i.key === x).value.length
                    }
                });

                let section3DataRowCount = 0;

                lValues.forEach((x) => {
                    if (dataRow.AC.find(i => i.key === x).value.length > section3DataRowCount) {
                        section3DataRowCount = dataRow.AC.find(i => i.key === x).value.length
                    }
                });

                let txt = `
<style>

table.table-sroh td {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}

table.table-sroh td:first-child {
    border-left: none;
}

table.table-sroh td:last-child {
    border-right: none;
}

table.table-sroh th {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-top: 1px solid #000;
}

table.table-sroh th:first-child {
    border-left: none;
}

table.table-sroh th:last-child {
    border-right: none;
}


table.table-sroh caption {
    font-weight: bold;
    font-size: 1.2em;
    caption-side: top;
}


table.table-sroh tr.border-bottom, table.table-sroh td.border-bottom {
    border-bottom: 1px solid #000 !important;
}

table.table-sroh tr.shaded, table.table-sroh td.shaded, table.table-sroh th.shaded {
 background-color: #E5EEFD;
}

tr.partition td,  tr.partition th {
    border-top: 2px solid black;
}

</style>
        <table role="table" class="table table-responsive table-sroh mt-4">
        <caption>${titleData.Title}</caption>
            <thead>
            <tr>
            <th class="shaded" style="width:15%; vertical-align:bottom">Existing</th>`;

                lValues.forEach((x) =>
                    txt += `<th class="shaded">${x}</th>`
                );

                txt += `
            </tr>
            </thead>
            <tbody>
           
            <tr class="border-bottom">
            <th style="width:30%;" rowspan="${section1DataRowCount}">If the existing surfacing is HRA or AC, HRA mixtures described on the right are acceptable. If the existing is TSCS or SMA the use of HRA is by agreement</th>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.HRA.find(i => i.key === x).value[0]}</td>`
                );

                txt += `
            </tr>`;

                for (let n = 1; n < section1DataRowCount; n++) {

                    txt += `<tr class="border-bottom">`;

                    lValues.forEach((x) => {
                        let value = dataRow.HRA.find(i => i.key === x).value[n];
                        if (value !== null && value !== undefined)
                            txt += `<td>${dataRow.HRA.find(i => i.key === x).value[n]}</td>`
                        else
                            txt += `<td style="text-align:center">-</td>`
                        }
                    );

                    txt += `</tr>`
                }

                txt += `
                <tr class="border-bottom partition">
                    <th rowspan = "${section2DataRowCount}">If the existing surfacing is SMA/TSCS or AC, the SMA mixtures described on the right are acceptable</th>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.SMA.find(i => i.key === x).value[0]}</td>`
                );

                txt += `
            </tr>`;

                for (let n = 1; n < section2DataRowCount; n++) {

                    txt += `<tr class="border-bottom">`;

                    lValues.forEach((x) => {
                        let value = dataRow.SMA.find(i => i.key === x).value[n];
                        if (value !== null && value !== undefined)
                            txt += `<td>${dataRow.SMA.find(i => i.key === x).value[n]}</td>`
                        else
                            txt += `<td style="text-align:center">-</td>`
                    }
                    );


                    txt += `</tr>`
                }


                txt += `
                <tr class="border-bottom partition">
                    <th rowspan = "${section3DataRowCount}">If the existing surfacing is AC the AC mixtures described on the right are acceptable</th>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.AC.find(i => i.key === x).value[0]}</td>`
                );

                txt += `
            </tr>`;

                for (let n = 1; n < section3DataRowCount; n++) {

                    txt += `<tr class="border-bottom">`;

                    lValues.forEach((x) => {
                        let value = dataRow.AC.find(i => i.key === x).value[n];
                        if (value !== null && value !== undefined)
                            txt += `<td>${dataRow.AC.find(i => i.key === x).value[n]}</td>`
                        else
                            txt += `<td style="text-align:center">-</td>`
                    }
                    );


                    txt += `</tr>`
                }

                txt += `
                <tr class="border-bottom partition">
                    <th>If the existing surfacing is SMA/TSCS</th>`;

                txt += `<td colspan="${lValues.length}" style="text-align:center">TSCS if required by the authority</td>`

                txt += `
            </tr>`;


                txt += `
            </tbody>

            <tfoot>
            <tr class="border-bottom">
            <td colspan="${lValues.length + 1}">

            * Only by agreement<br />
			** if trench is in carriageway and extends to the footway (maximum continuous 10 linear m or 4 m<sup>2</sup> or by agreement)<br />
			*** WTR1 is permitted for road type 1 for locations outside heavily stressed areas
            </td>
            </tr>
            </tfoot>

            
            </table>
            `;

               // render the table... 

                $get("tblRequirements").innerHTML = txt;

            }
            else {
                $get("tblRequirements").innerHTML = "";
            }

        };

        $get("btnShowRequirements").addEventListener("click", btnShowRequirementsClick);

    });

})();
